import domtoimage from 'dom-to-image-more'

type ScreenshotOptions = {
  scale?: number
}

export const useScreenshot = ({
  dataTestId,
  filename = 'screenshot.png',
  options,
}: {
  dataTestId: string
  filename?: string
  options?: ScreenshotOptions
}) => {
  const takeScreenshot = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()

    const element = document.querySelector<HTMLElement>(
      `[data-testid="${dataTestId}"]`,
    )

    if (!element) {
      console.error(`Element with data-testid "${dataTestId}" not found.`)
      return
    }

    try {
      const scale = options?.scale || window.devicePixelRatio * 3

      const blob = await domtoimage.toBlob(element, {
        width: element.scrollWidth * scale,
        height: element.scrollHeight * scale,
        style: {
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
        },
        bgcolor: '#ffffff',
      })

      if (!blob) {
        console.error('Could not generate blob.')
        return
      }

      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      link.click()
      URL.revokeObjectURL(url)
    } catch (err) {
      console.error('Screenshot generation failed', err)
    }
  }

  return { takeScreenshot }
}
